import { Heading } from '@chakra-ui/react'
import React from 'react'
import { Routers } from './routes'

export const App = () => {
  return (
    <>
      <Routers/>
      {/* <Heading color={'purple.500'}>App</Heading> */}
    </>
  )
}

